import * as React from 'react';
import { Footer as UnityFooter } from 'react-unity';

export default class Footer extends React.Component {

	LinkTo = (url: string, label: string) => (
		<UnityFooter.Link
			className="em-u-clickable"
			onClick={() => window.open(url, '_blank')}
		>
			{label}
		</UnityFooter.Link>
	);

	render() {
		return (
			<UnityFooter>
				<UnityFooter.Link>
						RELATED LINKS
				</UnityFooter.Link>
				<UnityFooter.Link>
						EXPLORE MA&P
				</UnityFooter.Link>
				{this.LinkTo('https://goto/cloud', 'goto/cloud')}
				{this.LinkTo('https://goto/map', 'goto/map')}
				{this.LinkTo('https://goto/eapublicdocs', 'EA Public Docs')}
				{this.LinkTo('https://goto/AppsHub', 'Applications Hub')}
				{this.LinkTo('https://portal.azure.cn/62d11549-4655-4f82-9472-c5c46ff13f3b', 'Azure Portal')}
			</UnityFooter>
		);
	}
}